import { render, staticRenderFns } from "./QAMyIndex.vue?vue&type=template&id=82f01e12"
import script from "./QAMyIndex.vue?vue&type=script&lang=js"
export * from "./QAMyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports